import Vue from 'vue'
import Vue18n from 'vue-i18n'

import Cn from './modules/cn'
import En from './modules/en'

//使用引入
Vue.use(Vue18n);

//定义标识符
const i18n = new Vue18n({
    locale: localStorage.getItem('LANGUAGE') || 'cn',    // 语言标识
    messages: {
        'cn': Cn,   // 中文语言包
        'en': En,    // 英文语言包
    }
})

export default i18n